// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1HBE_","modal":"Modal_modal__1gIA1","modalContent":"Modal_modalContent__3SgfK","contentCross":"Modal_contentCross__2pFD5","content":"Modal_content__1u-tw"};